/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, {useState, useContext, useCallback, useEffect} from 'react'
import moment from 'moment'
import { motion } from 'framer-motion';
import { distributorService } from '../../../service/distributor.service';
import HeaderContext from '../../../Components/Context/HeaderContext';
import OutstandingInvoiceReportFilterModal from './FilterModal';
import Pagination from '../../../Components/Pagination';
import {PriceHandler} from '../../../redux/helper/CamelCase'
import OrderListingSkeleton from '../../MyOrders/OrderListingSkeleton';
import EmptyOrderPage from '../../MyOrders/EmptyOrderPage';


const OutstandingInvoiceReport = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [outstandingInvoiceList, setOutstandingInvoiceList] = useState([]);
    const [sortType, setsortType] = useState('GST_INVOICE_DATE+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [filterModal, setFilterModal] = useState(false)
    const [filterValue, setfilterValue] = useState('');
    const [Filter, setFilter] = useState({
        class:[],
    })
    const [selected, setselected] = useState({
        invoice_start_date: '',
        invoice_end_date: '',
        ar_start_date: '',
        ar_end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');


    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;


    const handleOutstandingInvoiceReport = useCallback((() => {
        distributorService.MISOutstandingInvoiceDetails(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setOutstandingInvoiceList(response.data.data);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handleExport = useCallback((() => {
        distributorService.MISOutstandingInvoiceDetails(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, sortType,  searchValue, filterValue, exportSelected ).then((response) => {
            if (response.data.success_status) {
                SetSuccessMessage(response.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(response.data.url, '_blank');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    useEffect(() => {
        handleOutstandingInvoiceReport();
    }, [handleOutstandingInvoiceReport]);


    return (
        <div className="md:px-[46px] px-4 ">
            {(loading && !emptyData) ? <OrderListingSkeleton /> : (
                <div>
                    <div className="flex items-center pb-[10px] justify-between flex-wrap sm:pt-[30px] pt-3.5 top-0">
                        <h5 className="sm:text-xs10 text-lg font-semibold text-[#090406] lg:mb-0 mb-3">Outstanding Invoice Details Report</h5> 
                        <div className="lg:mb-0 mb-3">
                            <div className="flex sm:mx-2 mx-0 items-center flex-wrap w-full">
                                <button 
                                    type="button" 
                                    className="flex items-center bg-[#F5F5FA] font-bold text-xs text-[#555259] border-2 border-[#E9EDF4] sm:py-2.5 py-1.5 px-5 rounded-[9px]" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#filtermodal"
                                    onClick={() => setFilterModal(true) }
                                >
                                    {filterValue === '' ? '' :<span className='mr-1'><img src="/images/red-button.png"></img></span>}Filter
                                </button>
                                <div className="pl-2 dropdown relative">
                                    <button 
                                        type="button" 
                                        id="exportDropdown" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false" 
                                        className="dropdown-toggle text-xs2 font-semibold text-[#555259] sm:py-2.5 py-1.5 sm:px-4 px-2 border border-[#555259] rounded-lg"
                                        onClick={()=>setexportClick(!exportClick)} 
                                    >
                                        Generate Report
                                    </button>
                                    <ul className={`dropdown-menu sm:min-w-[125px] min-w-[120px] ${exportClick ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9] sm:p-3.5 p-1.5`} style={{zIndex: '9'}} aria-labelledby="exportDropdown">
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"  
                                                href="#"
                                                onClick={() => {
                                                    setexportSelected('csv')}}
                                            >CSV</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected(`pdf-converter`)}

                                            >PDF</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected('excel')}
                                            >Excel</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="ml-3 relative cursor-pointer">
                                    <input 
                                        type="text" 
                                        className="lg:w-[200px] w-[160px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" 
                                        placeholder="Search"
                                        value={searchValue}
                                        onChange={(e) => {
                                            setsearchValue(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                        autoComplete="off"
                                    />
                                    <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            {outstandingInvoiceList.length > 0 && (
                                <div className="overflow-x-auto dropdown-menu pb-7 relative z-[6]" style={{height: 'calc(100vh - 297px)'}}>
                                    <table className="w-full table-auto relative">
                                        <thead className='sticky top-0 left-0 z-[1]'>
                                            <tr className="bg-[#555259] h-10">
                                                <th className="py-2.5 sm:px-7 px-3 rounded-bl-lg rounded-tl-lg min-w-[136px] bg-[#555259] text-start sticky left-0" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Invoice No.
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[190px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                        Invoice Date
                                                        <a href="javascript:void(0)" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{ rotate: sortType === 'GST_INVOICE_DATE+asc' ? 180 : 0 }}
                                                                className={`${sortType === 'GST_INVOICE_DATE+desc' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'GST_INVOICE_DATE+asc') {
                                                                        setsortType('GST_INVOICE_DATE+desc');
                                                                    } else if (sortType === 'GST_INVOICE_DATE+desc') {
                                                                        setsortType('GST_INVOICE_DATE+asc');
                                                                    } else {
                                                                        setsortType('GST_INVOICE_DATE+asc');
                                                                    }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[124px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                        Org Code
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[90px] text-start">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Class
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[112px] text-start">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        AR No.
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                        AR Date
                                                        <a href="javascript:void(0)" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{ rotate: sortType === 'AR_DATE+asc' ? 180 : 0 }}
                                                                className={`${sortType === 'AR_DATE+desc' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'AR_DATE+asc') {
                                                                        setsortType('AR_DATE+desc');
                                                                    } else if (sortType === 'AR_DATE+desc') {
                                                                        setsortType('AR_DATE+asc');
                                                                    } else {
                                                                        setsortType('AR_DATE+asc');
                                                                    }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[343px] text-start">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Description
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] rounded-br-lg rounded-tr-lg text-start">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Total Outstanding
                                                    </span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {outstandingInvoiceList.length > 0 && outstandingInvoiceList.map((item, idx) => (
                                                <tr key={idx} className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                    <td className="sticky left-0 text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3" style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                                        {item?.GST_INVOICE_NUMBER}                     
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {item?.GST_INVOICE_DATE ? moment(item?.GST_INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss'): '-'}                      
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {item?.ORGANIZATION_NAME}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {item?.CLASS}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {item?.AR_NUMBER}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {item?.AR_DATE? moment(item?.AR_DATE).format('DD-MMM-YYYY, HH:mm:ss'): '-'}                       
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        <span className="more-lines" data-tooltip-target="tooltip-information" data-tooltip-placement="bottom" data-tooltip-trigger="hover" type="button">
                                                            {item?.DESCRIPTION}
                                                        </span>                                      
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                        {PriceHandler(item?.TOTAL_OUTSTANDING_RS)}
                                                    </td>
                                                </tr>
 
                                            ))}
                                
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            {outstandingInvoiceList.length > 0 && (
                                <Pagination
                                    handlePageClick={handlePageClick}
                                    List={outstandingInvoiceList}
                                    currentPage={currentPage}
                                    totalPage={totalPage}
                                />
                            )}                    
                        </div>
            
                        {filterModal && <OutstandingInvoiceReportFilterModal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal} 
                            selected={selected}
                            setselected={setselected}
                            Filter={Filter}
                            setFilter={setFilter}
                            handleFilter={handleFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleOutstandingInvoiceReport={handleOutstandingInvoiceReport}
                            outstandingInvoiceList={outstandingInvoiceList}
                            setOutstandingInvoiceList={setOutstandingInvoiceList}
                            SetSuccessMessage={SetSuccessMessage}
                        />}
                    </div>
                    {emptyData && <EmptyOrderPage search="yes" text="no Outstanding Invoice Details Report" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}

                </div>
            )}
        </div>
    )
}

export default OutstandingInvoiceReport
